import { gql } from "@apollo/client";
export const typeDef = gql`
  type PinActivateResult @cacheControl(scope: PRIVATE, maxAge: 0) {
    status: String
    result: Boolean
    deviceToken: String
  }

  type Mutation {
    pinActivate(code: String): PinActivateResult
  }
`;
export const resolvers = {
  Mutation: {
    pinActivate: async (_parent, _ref, _ref2) => {
      let {
        code
      } = _ref;
      let {
        dataSources
      } = _ref2;
      try {
        const res = await dataSources.pinManager.pinActivate(code);
        return {
          status: res === null || res === void 0 ? void 0 : res.status,
          result: res === null || res === void 0 ? void 0 : res.result,
          deviceToken: res === null || res === void 0 ? void 0 : res.device_token
        };
      } catch (e) {
        console.log("pinActivate schema error in resolver", e);
        return {
          result: false
        };
      }
    }
  }
};